import type { KeyboardEvent as TReactKeyboardEvent } from 'react';

/**
 * Which key this machine's keyboard actually has for the modifier — a mac prints
 * ⌘, everything else prints Ctrl. Drawing the wrong one teaches a shortcut
 * nobody's keyboard has.
 */
export const IS_MAC = /Mac|iPhone|iPad/.test(navigator.userAgent);

/**
 * Both modifiers on every platform: a mac user on an external PC keyboard
 * reaches for Ctrl, and a Windows user on a mac keyboard reaches for ⌘.
 * Accepting only the platform's own would be a shortcut that works at one desk.
 */
export const isSubmitChord = (event: KeyboardEvent | TReactKeyboardEvent<HTMLElement>): boolean =>
  (event.metaKey || event.ctrlKey) && event.key === 'Enter';
